(function () {
  'use strict';

  function parseOptions(el) {
    var raw = el.getAttribute('data-flickity');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  function setActiveThumb(thumbs, index) {
    if (!thumbs) return;
    thumbs.querySelectorAll('.pr_thumbs_item').forEach(function (item, i) {
      var link = item.querySelector('.pr_thumb, .gitem-img');
      var isActive = i === index;
      item.classList.toggle('active-thumb', isActive);
      if (link) link.classList.toggle('activeSlide', isActive);
    });
  }

  function wireThumbNav(container, mainSlider, thumbs) {
    if (!mainSlider || !thumbs || !mainSlider._pdpFlickity) return;
    if (thumbs.dataset.pdpThumbsWired === 'true') return;
    thumbs.dataset.pdpThumbsWired = 'true';

    var flkty = mainSlider._pdpFlickity;

    thumbs.querySelectorAll('[data-slide]').forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var i = parseInt(thumb.getAttribute('data-slide'), 10);
        if (!isNaN(i)) flkty.select(i);
      });
    });

    var prevBtn = thumbs.querySelector('.flickity-button.previous');
    var nextBtn = thumbs.querySelector('.flickity-button.next');
    var thumbsWrap = thumbs.querySelector('.pr_thumbsWr, .pr_thumbs');

    function scrollThumbs(dir) {
      if (!thumbsWrap) return;
      var amount = 80;
      var isVertical = window.matchMedia('(min-width: 768px)').matches && !thumbs.classList.contains('bottom');
      if (isVertical) {
        thumbsWrap.scrollTop += dir * amount;
      } else {
        thumbsWrap.scrollLeft += dir * amount;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        flkty.previous();
        scrollThumbs(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        flkty.next();
        scrollThumbs(1);
      });
    }

    flkty.on('select', function () {
      setActiveThumb(thumbs, flkty.selectedIndex);
    });
    setActiveThumb(thumbs, flkty.selectedIndex);
  }

  function disableMediaClickOpen(scope) {
    var root = scope || document;
    root.querySelectorAll('.m_ptContainer .primgSlider .pr_photo').forEach(function (el) {
      if (el.dataset.pdpNoOpen === 'true') return;
      el.dataset.pdpNoOpen = 'true';
      el.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    });
  }

  function initFlickity(scope) {
    if (typeof Flickity === 'undefined') return;
    var root = scope || document;
    root.querySelectorAll('.primgSlider[data-flickity], .merox_slideshow .slideshow[data-flickity]').forEach(function (el) {
      if (el.dataset.pdpFlickityInit === 'true') return;
      try {
        var flkty = new Flickity(el, parseOptions(el));
        el.dataset.pdpFlickityInit = 'true';
        el._pdpFlickity = flkty;
      } catch (err) {
        console.warn('PDP Flickity init failed', err);
      }
    });

    root.querySelectorAll('.m_ptContainer, .ptContainer, [data-section-type="product"]').forEach(function (container) {
      var mainSlider = container.querySelector('.primgSlider');
      var thumbs = container.querySelector('.thumbs_nav');
      wireThumbNav(container, mainSlider, thumbs);
    });

    disableMediaClickOpen(root);
  }

  function boot(scope) {
    if (typeof Flickity === 'undefined') {
      setTimeout(function () {
        boot(scope);
      }, 50);
      return;
    }
    initFlickity(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
